
<script setup>
import { useRouter } from 'vue-router'

definePage({
  meta: {
    name: "Dashboard",
    subject: "survey.menu",
    action: "dashboard",
  },
})

const router = useRouter()

const surveys = [
  {
    title: "Patient Satisfaction Surveys",
    description: "Track patient experience and identify areas for improvement.",
    image: "/assets/survey/survey3.jpg",
  },
  {
    title: "Employee Engagement Survey",
    description: "Measure employee satisfaction and identify areas for improvement.",
    image: "/assets/survey/survey2.jpg",
  },
  {
    title: "Event Feedback Surveys",
    description: "Gather feedback from attendees to improve future events.",
    image: "/assets/survey/survey1.jpg",
  },
]
</script>

<template>
  <VCard
    variant="flat"
    class="border"
  >
    <VCardText>
      <h2 class="text-h5 font-weight-bold text-primary">
        Dashboard
      </h2>
      <span class="text-body-2">
        Overview of all survey activities and results
      </span>
    </VCardText>
    <VDivider />
    <VCardText>
      <VRow class="py-6">
        <VCol
          v-for="(survey, index) in surveys"
          :key="index"
          cols="12"
          md="4"
        >
          <VCard variant="outlined">
            <VImg
              :src="survey.image"
              height="230px"
              cover
            />
            <VCardText>
              <h3 class="text-subtitle-1 font-weight-bold">
                {{ survey.title }}
              </h3>
              <p class="text-body-2">
                {{ survey.description }}
              </p>
            </VCardText>
          </VCard>
        </VCol>
      </VRow>
    </VCardText>  
  </VCard>

  <!--
    <VRow>
    <VCol cols="3">
    <VCard>
    <VCardText>
    <div class="text-h2">
    55
    </div>
    <div class="text-h5">
    Total Surveys
    </div>
    </VCardText>
    </VCard>
    </VCol>
    <VCol cols="3">
    <VCard>
    <VCardText>
    <div class="text-h2">
    55
    </div>
    <div class="text-h5">
    Total Responses
    </div>
    </VCardText>
    </VCard>
    </VCol>
    <VCol cols="3">
    <VCard>
    <VCardText>
    <div class="text-h2">
    55
    </div>
    <div class="text-h5">
    Pending Schedules
    </div>
    </VCardText>
    </VCard>
    </VCol>
    <VCol cols="3">
    <VCard>
    <VCardText>
    <div class="text-h2">
    55
    </div>
    <div class="text-h5">
    Collect Response
    </div>
    </VCardText>
    </VCard>
    </VCol>
    </VRow> 
  -->
</template>
